<template>
  <v-dialog v-model="isOpen" max-width="500" persistent>
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-form @submit.prevent="submit()">
        <v-card-title>
          ตัวกรอง
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localValue.search"
                outlined
                label="ข้อมูลเครื่อง"
                hide-details
              />
            </v-col>
            <v-col cols="6">
              <DatepickerCustom v-model="localValue.startDate">
                <template #default="{ on }">
                  <v-text-field
                    :value="formattedDate(localValue.startDate)"
                    outlined
                    label="เริ่ม"
                    hide-details
                    readonly
                    append-icon="mdi-calendar"
                    v-on="on"
                  />
                </template>
              </DatepickerCustom>
            </v-col>
            <v-col cols="6">
              <DatepickerCustom v-model="localValue.endDate">
                <template #default="{ on }">
                  <v-text-field
                    :value="formattedDate(localValue.endDate)"
                    outlined
                    label="สิ้นสุด"
                    hide-details
                    readonly
                    append-icon="mdi-calendar"
                    v-on="on"
                  />
                </template>
              </DatepickerCustom>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="clear()">ล้างการค้นหา</v-btn>
          <v-btn color="primary" type="submit">ตกลง</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DatepickerCustom from "@/components/DatepickerCustom.vue";
import moment from "moment";

export default {
  components: { DatepickerCustom },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      localValue: {
        search: "",
        startDate: "",
        endDate: "",
        ...this.value,
      },
    };
  },
  watch: {
    value(value) {
      this.localValue = { ...this.localValue, ...value };
    },
    isOpen(value) {
      if (value) {
        const { search = "", startDate = "", endDate = "" } = this.value || {};
        this.localValue = { search, startDate, endDate };
      }
    },
  },
  methods: {
    formattedDate(value) {
      if (!value) return "";
      return moment(value).format("DD/MM/YYYY");
    },
    submit() {
      this.$emit("input", this.localValue);
      this.close();
    },
    close() {
      this.isOpen = false;
    },
    clear() {
      this.$emit("input", null);
      this.close();
    },
  },
};
</script>
